export const START_PRODUCTION = 'START_PRODUCTION';
export const START_PRODUCTION_SUCCESS = 'START_PRODUCTION_SUCCESS';
export const START_PRODUCTION_FAILED = 'START_PRODUCTION_FAILED';

export const GET_PRODUCTION = 'GET_PRODUCTION';
export const GET_PRODUCTION_SUCCESS = 'GET_PRODUCTION_SUCCESS';
export const GET_PRODUCTION_FAILED = 'GET_PRODUCTION_FAILED';

export const GET_BULK_PRODUCTION = 'GET_BULK_PRODUCTION';
export const GET_BULK_PRODUCTION_SUCCESS = 'GET_BULK_PRODUCTION_SUCCESS';
export const GET_BULK_PRODUCTION_FAILED = 'GET_BULK_PRODUCTION_FAILED';

export const GET_PRODUCTION_BY_ID = 'GET_PRODUCTION_BY_ID';
export const GET_PRODUCTION_BY_ID_SUCCESS = 'GET_PRODUCTION_BY_ID_SUCCESS';
export const GET_PRODUCTION_BY_ID_FAILED = 'GET_PRODUCTION_BY_ID_FAILED';

export const UPDATE_PROCESS = 'UPDATE_PROCESS';
export const UPDATE_PROCESS_SUCCESS = 'UPDATE_PROCESS_SUCCESS';
export const UPDATE_PROCESS_FAILED = 'UPDATE_PROCESS_FAILED';

export const UPDATE_COST = 'UPDATE_COST';
export const UPDATE_COST_SUCCESS = 'UPDATE_COST_SUCCESS';
export const UPDATE_COST_FAILED = 'UPDATE_COST_FAILED';

export const SAVE_FINISHED_GOODS = 'SAVE_FINISHED_GOODS';
export const SAVE_FINISHED_GOODS_SUCCESS = 'SAVE_FINISHED_GOODS_SUCCESS';
export const SAVE_FINISHED_GOODS_FAILED = 'SAVE_FINISHED_GOODS_FAILED';

export const SAVE_REWORK = 'SAVE_REWORK';
export const SAVE_REWORK_SUCCESS = 'SAVE_REWORK_SUCCESS';
export const SAVE_REWORK_FAILED = 'SAVE_REWORK_FAILED';

export const UPDATE_PRODUCTION_STATUS = 'UPDATE_PRODUCTION_STATUS';
export const UPDATE_PRODUCTION_STATUS_SUCCESS = 'UPDATE_PRODUCTION_STATUS_SUCCESS';
export const UPDATE_PRODUCTION_STATUS_FAILED = 'UPDATE_PRODUCTION_STATUS_FAILED';

export const UPDATE_SCRAP_LOGS = 'UPDATE_SCRAP_LOGS';
export const UPDATE_SCRAP_LOGS_SUCCESS = 'UPDATE_SCRAP_LOGS_SUCCESS';
export const UPDATE_SCRAP_LOGS_FAILED = 'UPDATE_SCRAP_LOGS_FAILED';

export const SAVE_PRODUCTION = 'SAVE_PRODUCTION';
export const SAVE_PRODUCTION_SUCCESS = 'SAVE_PRODUCTION_SUCCESS';
export const SAVE_PRODUCTION_FAILED = 'SAVE_PRODUCTION_FAILED';

export const MATERIAL_PLANNING = 'MATERIAL_PLANNING';
export const MATERIAL_PLANNING_SUCCESS = 'MATERIAL_PLANNING_SUCCESS';
export const MATERIAL_PLANNING_FAILED = 'MATERIAL_PLANNING_FAILED';


export const MIN_STOCK_MATERIAL_PLANNING = 'MIN_STOCK_MATERIAL_PLANNING';
export const MIN_STOCK_MATERIAL_PLANNING_SUCCESS = 'MIN_STOCK_MATERIAL_PLANNING_SUCCESS';
export const MIN_STOCK_MATERIAL_PLANNING_FAILED = 'MIN_STOCK_MATERIAL_PLANNING_FAILED';

export const BOM_BASED_MATERIAL_PLANNING = 'BOM_BASED_MATERIAL_PLANNING';
export const BOM_BASED_MATERIAL_PLANNING_SUCCESS = 'BOM_BASED_MATERIAL_PLANNING_SUCCESS';
export const BOM_BASED_MATERIAL_PLANNING_FAILED = 'BOM_BASED_MATERIAL_PLANNING_FAILED';

export const GET_PRODUCTIONS_BY_COMPANY_ID = 'GET_PRODUCTIONS_BY_COMPANY_ID';
export const GET_PRODUCTIONS_BY_COMPANY_ID_SUCCESS = 'GET_PRODUCTIONS_BY_COMPANY_ID_SUCCESS';
export const GET_PRODUCTIONS_BY_COMPANY_ID_FAILED = 'GET_PRODUCTIONS_BY_COMPANY_ID_FAILED';

export const PRODUCTION_BASED_MATERIAL_PLANNING = 'PRODUCTION_BASED_MATERIAL_PLANNING';
export const PRODUCTION_BASED_MATERIAL_PLANNING_SUCCESS = 'PRODUCTION_BASED_MATERIAL_PLANNING_SUCCESS';
export const PRODUCTION_BASED_MATERIAL_PLANNING_FAILED = 'PRODUCTION_BASED_MATERIAL_PLANNING_FAILED';

export const UPDATE_TABLE = 'UPDATE_TABLE';
export const UPDATE_TABLE_SUCCESS = 'UPDATE_TABLE_SUCCESS';
export const UPDATE_TABLE_FAILED = 'UPDATE_TABLE_FAILED';

export const REMOVE_ROWS = 'REMOVE_ROWS';
export const REMOVE_ROWS_SUCCESS = 'REMOVE_ROWS_SUCCESS';
export const REMOVE_ROWS_FAILED = 'REMOVE_ROWS_FAILED';

export const VIEW_PRODUCTION_HISTORY = 'VIEW_PRODUCTION_HISTORY';
export const VIEW_PRODUCTION_HISTORY_SUCCESS = 'VIEW_PRODUCTION_HISTORY_SUCCESS';
export const VIEW_PRODUCTION_HISTORY_FAILED = 'VIEW_PRODUCTION_HISTORY_FAILED';

export const RETURN_RAW_MATERIAL = 'RETURN_RAW_MATERIAL';
export const RETURN_RAW_MATERIAL_SUCCESS = 'RETURN_RAW_MATERIAL_SUCCESS';
export const RETURN_RAW_MATERIAL_FAILED = 'RETURN_RAW_MATERIAL_FAILED';

export const START_BULK_PRODUCTION = 'START_BULK_PRODUCTION';
export const START_BULK_PRODUCTION_SUCCESS = 'START_BULK_PRODUCTION_SUCCESS';
export const START_BULK_PRODUCTION_FAILED = 'START_BULK_PRODUCTION_FAILED';

export const GET_BULK_PRODUCTIONS = 'GET_BULK_PRODUCTIONS';
export const GET_BULK_PRODUCTIONS_SUCCESS = 'GET_BULK_PRODUCTIONS_SUCCESS';
export const GET_BULK_PRODUCTIONS_FAILED = 'GET_BULK_PRODUCTIONS_FAILED';

export const GET_REMAINING_PRODUCTION = 'GET_REMAINING_PRODUCTION';
export const GET_REMAINING_PRODUCTION_SUCCESS = 'GET_REMAINING_PRODUCTION_SUCCESS';
export const GET_REMAINING_PRODUCTION_FAILED = 'GET_REMAINING_PRODUCTION_FAILED';

export const DISCARD_PRODUCTION = 'DISCARD_PRODUCTION';
export const DISCARD_PRODUCTION_SUCCESS = 'DISCARD_PRODUCTION_SUCCESS';
export const DISCARD_PRODUCTION_FAILED = 'DISCARD_PRODUCTION_FAILED';

export const BULK_ISSUE = 'BULK_ISSUE';
export const BULK_ISSUE_SUCCESS = 'BULK_ISSUE_SUCCESS';
export const BULK_ISSUE_FAILED = 'BULK_ISSUE_FAILED';

export const UPDATE_START_DATE = 'UPDATE_START_DATE';
export const UPDATE_START_DATE_SUCCESS = 'UPDATE_START_DATE_SUCCESS';
export const UPDATE_START_DATE_FAILED = 'UPDATE_START_DATE_FAILED';

export const GET_ALL_PRODUCTIONS = 'GET_ALL_PRODUCTIONS';
export const GET_ALL_PRODUCTIONS_SUCCESS = 'GET_ALL_PRODUCTIONS_SUCCESS';
export const GET_ALL_PRODUCTIONS_FAILED = 'GET_ALL_PRODUCTIONS_FAILED';

export const DELETE_LOGS = 'DELETE_LOGS';
export const DELETE_LOGS_SUCCESS = 'DELETE_LOGS_SUCCESS';
export const DELETE_LOGS_FAILED = 'DELETE_LOGS_FAILED';